// @core/stores/task/TaskContainerConfigStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { taskApi } from '@core/api';
import type {
  ContainerConfigResponse,
  CreateContainerConfigRequest,
  UpdateContainerConfigRequest,
} from '@core/types/task';

class TaskContainerConfigStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Create container config
   */
  async CreateContainerConfig(data: CreateContainerConfigRequest): Promise<ContainerConfigResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await taskApi.CreateContainerConfig(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Delete container config
   */
  async DeleteContainerConfig(config_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await taskApi.DeleteContainerConfig(config_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get container config
   */
  async GetContainerConfig(config_id: string): Promise<ContainerConfigResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await taskApi.GetContainerConfig(config_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get container config by entity
   */
  async GetContainerConfigByEntity(entity_type: string, entity_id: string): Promise<ContainerConfigResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await taskApi.GetContainerConfigByEntity(entity_type, entity_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update container config
   */
  async UpdateContainerConfig(config_id: string, data: UpdateContainerConfigRequest): Promise<ContainerConfigResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await taskApi.UpdateContainerConfig(config_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const taskContainerConfigStore = new TaskContainerConfigStore();
